enum MethodType {
  GET = 'GET',
  POST = 'POST',
}

export enum HttpStatus {
  Success = 200,
  Created = 201,
  NotFound = 404,
  ServerError = 500,
}

const standardHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export interface CreateTicketRequest {
  kiosk_id: string;
  request_uuid: string;
  option: string;
  category: string;
  subcategory: string;
  priority: string;
  isExternal: boolean;
  notifyType: string;
  notifyId: number;
  feedback: string;
}

export interface CreateSentimentRequest {
  kiosk_id: string;
  request_uuid: string;
  name: string;
  value: number;
  feedbackOption: string;
  feedbackSubOption: string;
}

const API_URL = process.env.REACT_APP_API_BASE_URL;

class ApiService {
  async createSentiment(
    kioskId: string,
    request: CreateSentimentRequest,
  ): Promise<Response> {
    return fetch(`${API_URL}api/v3/kiosks/${kioskId}/sentiment/`, {
      method: MethodType.POST,
      headers: standardHeaders,
      body: JSON.stringify(request),
    });
  }

  async createTicket(
    kioskId: string,
    request: CreateTicketRequest,
  ): Promise<Response> {
    return fetch(`${API_URL}api/v3/kiosks/${kioskId}/tickets/`, {
      method: MethodType.POST,
      headers: standardHeaders,
      body: JSON.stringify(request),
    });
  }
  async fetchApiConfig(kioskId: string): Promise<Response> {
    return fetch(`${API_URL}api/v3/kiosks/${kioskId}/configuration/`, {
      method: MethodType.GET,
      headers: standardHeaders,
    });
  }
}

export default new ApiService();
